import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { NumberOfOfficesOptions } from 'enums/onboarding/crm';
import { FormSelectProps, SelectOption } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const NumberOfOfficesSelectIntakeForm = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(NumberOfOfficesOptions).map((key) => ({
        id: key,
        label: t(`intake_form.number_of_offices_options.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default NumberOfOfficesSelectIntakeForm;
